<template>
        <div class="" >
			<div class="top-navigation-container">
				<div class="text-white">
					<span class="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/about-us">
							About Us
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/investors">
							Investors
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a
							target="_blank"
							href="https://www.emerson.com/en-us/careers/diversity-and-inclusion"
						>
							Diversity
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/careers">
							Careers
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a
							target="_blank"
							href="https://www.emerson.com/en-us/esg/sustainability"
						>
							Sustainability
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/contact-us">
							Contact Us
						</a>
					</span>
					<span class="ml-12 hover:underline cursor-pointer">
						<a target="_blank" href="https://www.emerson.com/en-us/news">
							Newsroom
						</a>
					</span>
				</div>
			</div>
			<div class="top-navigation-secondary-container">
				
				<div style="display:flex;width:1180px;">
					<div class="top-navigation-secondary-image">
					<a target="_blank" href="https://www.emerson.com/en-us">
						<img src='../assets/images/emerson-logo.png' alt="emerson_logo" width="96px" />
					</a>
				</div>
				<div class="top-navigation-secondary-group">
					
					<div class="top-navigation-secondary-group-item">
						<span class="w-24 lg:w-52 md:w-52 lg:ml-40 md:ml-40 cursor-pointer hover:text-navy-blue">
							<a
								target="_blank"
								href="https://www.emerson.com/en-us/automation-solutions"
							>
								AUTOMATION SOLUTIONS
							</a>
						</span>
					</div>
					<div class="top-navigation-secondary-group-item">
						<span class="w-44 lg:w-72 md:w-full cursor-pointer hover:text-navy-blue">
							<a
								target="_blank"
								href="https://www.emerson.com/en-us/commercial-residential-solutions"
							>
								COMMERCIAL & RESIDENTIAL SOLUTIONS
							</a>
						</span>
					</div>
				</div>
				</div>
			</div>
		</div>
</template>

<script>
export default {
  name:"EmersonHeader"
}
</script>
<style scoped>
@font-face {
    font-family: 'Noto Sans';
    src: url('../fonts/Noto_Sans/NotoSans-Light.ttf') format("truetype");
}
.top-navigation-container{
    background-color: black;
    font-family: 'Noto Sans'!important ;
    font-weight: 500;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: .875rem;
	text-align: right;
	justify-content: center;
	padding-right: 20vw;
}
.top-navigation-container a{
    color: white;
    text-decoration: none;
}

.top-navigation-secondary-container{
    display: flex;
	height: 55px;
    box-shadow: 0 3px 3px rgba(0,0,0,0.2);
	justify-content: center;
}
.top-navigation-secondary-image{
    margin-right: 4%;
}
.top-navigation-secondary-group{
    display: grid;
    grid-template-columns: auto auto;
}
.top-navigation-secondary-group-item{
    text-align: center;
    padding: 20px;
    justify-content: center;
    font-family: 'Noto Sans'!important ;
    font-weight: 600;
    font-size: .875rem;
    letter-spacing:.08em;
}
.top-navigation-secondary-group-item a{
    text-decoration: none;
    color: #2d383f;
}
a:active, a:hover{
    color: #00aa7e!important;
}

</style>